import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import React from 'react';
import DesktopDevPageDisplayStage728x90Gak from './gak/DesktopDevPageDisplayStage728x90';
import DesktopDevPageDisplayStage728x90Nitro from './nitro/DesktopDevPageDisplayStage728x90';
const DesktopDevPageDisplayStage728x90 = ({ safety ='off'  })=>{
    const isDaAds = useFlag('ads_da');
    if (isDaAds) {
        return /*#__PURE__*/ React.createElement(DesktopDevPageDisplayStage728x90Gak, {
            safety: safety
        });
    }
    return /*#__PURE__*/ React.createElement(DesktopDevPageDisplayStage728x90Nitro, {
        safety: safety
    });
};
DesktopDevPageDisplayStage728x90.displayName = 'DesktopDevPageDisplayStage728x90';
export default DesktopDevPageDisplayStage728x90;
